import DataCollectionCheckpoint from '../DataCollectionCheckpoint/DataCollectionCheckpoint'
import SetupRouter from '../SetupRouter'
import { AuthConsumer } from '@eggplant/context'
import { GetUnauthenticatedAiStatusRequest } from '@eggplant/api-requests'
import type { AiStatusResponse } from '@eggplant/types'

const LicenseCheckpoint = () =>
  <GetUnauthenticatedAiStatusRequest>
    {
      (
        {
          eula_accepted,
          has_valid_license
        }: AiStatusResponse
      ) =>
        <AuthConsumer>
          {
            ({ accessibleRoles }) =>
              eula_accepted &&
              has_valid_license &&
              accessibleRoles?.length
                ? <DataCollectionCheckpoint />
                : <SetupRouter />
          }
        </AuthConsumer>
    }
  </GetUnauthenticatedAiStatusRequest>

export default LicenseCheckpoint
